<template>
  <ButtonStyle v-if="id" v-slot="{ classes }" v-bind="buttonStyle">
    <button
      :class="[classes, { 'is-loading': isLoading }]"
      :disabled="!inStock || isUnavailable"
      @click="onClick"
    >
      <SpriteSymbol name="cart" class="w-25 h-30 mr-10" />

      <span v-if="!inStock">{{ $texts('outOfStock', 'Nicht auf Lager') }}</span>
      <span v-else>{{ $texts('addToCart', 'In den Warenkorb') }}</span>
    </button>
  </ButtonStyle>
</template>

<script lang="ts" setup>
import { useCartStore } from '~/stores/cart'
import type { VariationAddToCartFragment } from '#graphql-operations'
import { useNotifications } from '~/stores/notifications'

const store = useCartStore()
const notify = useNotifications()
const { $texts } = useNuxtApp()
const isLoading = ref(false)

const props = defineProps<{
  id?: string
  title?: string
  price?: VariationAddToCartFragment['price']
  inStock?: VariationAddToCartFragment['inStock']
  isUnavailable?: boolean
  color?: string
}>()

const buttonStyle = computed(() => {
  return {
    [props.color || 'green']: true,
  }
})

async function onClick() {
  isLoading.value = true
  try {
    await store.addProduct(props.id!)
  } catch {
    notify.error(
      $texts('unexpectedError', 'Es ist ein unerwarteter Fehler passiert.'),
    )
  }
  isLoading.value = false
}
</script>
